import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {
					font: {
						family: 'Arial',
						size: '16px',
					},
				},
				headerWrapper: {
					text: {
						align: 'center',
					},
					overrides: [
						{
							selector: 'h1',
							style: {
								display: 'inline-block',
							},
						},
					],
				},
				redirectButtonWrapper: {
					text: {
						align: 'center',
					},
					padding: {
						top: '80px',
					},
				},
			},
		},
		fundCard: {
			children: {
				wrapper: {
					width: '325px',
					min: {
						height: '310px',
					},
					position: 'relative',
					lineHeight: '19px',
					margin: {
						_value: '10px',
					},
					padding: {
						_value: '25px',
						top: '40px',
					},
					border: {
						top: {
							_value: 'solid 4px #C21B17',
						},
					},
					box: {
						shadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
					},
					overrides: [
						{
							selector: '[data-selector="base-redirectButton-wrapper"]',
							style: {
								position: 'absolute',
								bottom: '25px',
							},
						},
					],
				},
			},

		},
	},
	theme: {
		base: {
			definitionList: {
				font: {
					size: '14px',
				},
				lineHeight: '16px',
				color: '#C21B17',
			},
			heading: {
				text: {
					transform: 'uppercase',
				},
				children: {
					h1: {
						color: '#333333',
						font: {
							size: '32px',
							weight: 'normal',
						},
						lineHeight: '26px',
						border: {
							bottom: {
								_value: 'solid 1px #C02626',
							},
						},
						padding: {
							bottom: '10px',
							left: '5px',
							right: '5px',
						},
						margin: {
							block: {
								start: '20px',
								end: '20px',
							},
							left: '-5px',
							right: '-5px',
						},
					},
					h2: {
						color: '#333333',
						font: {
							size: '20px',
							weight: 'bold',
						},
						lineHeight: '26px',
						border: {
							bottom: {
								_value: 'solid 1px #C02626',
							},
						},
						padding: {
							bottom: '10px',
							left: '5px',
							right: '5px',
						},
						margin: {
							block: {
								start: '20px',
								end: '20px',
							},
							left: '-5px',
							right: '-5px',
						},
					},
				},
			},
			text: {
				margin: {
					bottom: '10px',
				},
			},
			button: {
				border: {
					_value: 'solid 2px #C02626',
				},
				text: {
					transform: 'uppercase',
				},
				color: '#C02626',
				font: {
					size: '14px',
					weight: 'bold',
				},
				lineHeight: '16px',
				padding: {
					_value: '15px',
				},
				margin: {
					left: '-5px',
					right: '-5px',
				},
			},
			carousel: {
				children: {
					wrapper: {
						width: '100%',
					},
					content: {
						display: 'flex',
					},
					navWrapper: {
						flex: {
							grow: '0',
						},
						padding: {
							_value: '4px',
						},
					},
					navLeft: {
						margin: {
							_value: 'auto',
						},
						width: '30px',
						height: '30px',
						text: {
							align: 'center',
						},
						lineHeight: '30px',
						border: {
							radius: '50%',
						},
					},
					navRight: {
						margin: {
							_value: 'auto',
						},
						width: '30px',
						height: '30px',
						text: {
							align: 'center',
						},
						lineHeight: '30px',
						border: {
							radius: '50%',
						},
					},
					componentWrapper: {
						transition: {
							_value: 'all 300ms ease-in-out',
						},
						display: 'flex',
						justifyContent: 'center',
					},
					dot: {
						width: '16px',
						height: '16px',
						background: {
							color: '#DDDDDD',
						},
						border: {
							radius: '50%',
						},
						conditionals: [
							{
								conditional: {
									conditions: [
										{
											field: 'selected',
											operator: '=',
											value: true,
										},
									],
								},
								style: {
									background: {
										color: 'blue',
									},
								},
							},
						],
					},
					dotWrapper: {
						padding: {
							left: '10px',
							right: '10px',
						},
					},
					dots: {
						display: 'flex',
						justifyContent: 'center',
					},
				},
			},
			dropdown: {
				children: {
					header: {
						border: {
							bottom: {
								width: '2px',
								style: 'solid',
								color: '#C02626',
							},
						},
						position: 'relative',
						display: 'inline-block',
						lineHeight: '40px',
						width: '100%',
						padding: {
							left: '5px',
						},
						font: {
							weight: 'bold',
						},
					},
					headerTitle: {
						float: 'left',
					},
					headerIcon: {
						float: 'right',
					},
					listItems: {
						position: 'absolute',
						background: {
							color: '#FFF',
						},
						zIndex: '1000',
						listStyle: {
							type: 'none',
						},
						display: 'inline-block',
						width: '80%',
						margin: {
							_value: '0',
						},
						padding: {
							_value: '0',
						},
					},
					listItem: {
						padding: {
							bottom: '5px',
							top: '5px',
							left: '5px',
						},
						selectors: {
							':hover': {
								background: {
									color: '#0075BE',
								},
								color: '#FFF',
							},
						},
						border: {
							bottom: {
								_value: '1px solid #D9DCE1',
							},
						},
					},
					clickLayer: {
						zIndex: '999',
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
					},
				},
			},
		},
		fact: {
			summaryBlocks: {
				children: {
					row: {
						display: 'flex',
					},
					block: {
						flex: {
							_value: 'auto',
						},
						margin: {
							_value: '4px',
						},
						overrides: [
							{
								selector: '[data-selector="fact-summaryBlock-wrapper"]',
								style: {
									min: {
										height: '90px',
									},
									max: {
										height: '120px',
									},
								},
							},
						],
					},
				},
			},
			summaryBlock: {
				children: {
					wrapper: {
						text: {
							align: 'center',
						},
						border: {
							color: '#dddddd',
							style: 'solid',

							right: {
								width: '1px',
							},
							left: {
								width: '1px',
							},
							top: {
								width: '0px',
							},
							bottom: {
								width: '3px',
							},
							radius: '3px',
						},
						padding: {
							_value: '10px',
						},
						overrides: [
							{
								selector: '[data-selector="fact-fact-title"]',
								style: {
									margin: {
										bottom: '10px',
									},
								},
							},
							{
								selector: '[data-selector="fact-fact-subtitle"]',
								style: {
									margin: {
										bottom: '10px',
									},
								},
							},
							{
								selector: '[data-selector="fact-fact-valueText"]',
								style: {
									color: 'dodgerblue',
									font: {
										size: 'larger',
									},
								},
							},
						],
					},
				},
			},
		},
	},
};